import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { palette } from '../theme';

const BrandMark: React.FC<{ size?: number }> = ({ size = 56 }) => (
  <div style={{
    width: size, height: size, flexShrink: 0, display: 'flex',
    clipPath: 'polygon(50% 0%, 100% 15%, 100% 58%, 50% 100%, 0% 58%, 0% 15%)',
  }}>
    <div style={{ flex: 1, background: palette.navy }} />
    <div style={{ flex: 1, background: palette.blue }} />
  </div>
);

const fieldStyle: React.CSSProperties = {
  height: 44, borderRadius: 8, border: `1px solid ${palette.border}`,
  background: palette.cream, fontSize: 14,
};

const LoginPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onLogin = async (values: { username: string; password: string }) => {
    setLoading(true);
    try {
      const res = await api.post('/auth/login', values);
      localStorage.setItem('token', res.data.access_token);
      localStorage.setItem('username', res.data.username);
      localStorage.setItem('role', res.data.role);
      message.success('Вход выполнен');
      navigate('/');
    } catch {
      message.error('Неверное имя пользователя или пароль');
    }
    setLoading(false);
  };

  return (
    <div className="login-page" style={{ background: palette.bg }}>
      <div style={{
        flex: 1, position: 'relative', padding: '72px 56px', display: 'flex',
        flexDirection: 'column', justifyContent: 'center', minHeight: 320, overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', top: -40, right: -60, width: 340, height: 340, opacity: 0.5,
          backgroundImage: `repeating-linear-gradient(115deg, ${palette.navy} 0px, ${palette.navy} 1.5px, transparent 1.5px, transparent 22px)`,
        }} />
        <BrandMark />
        <div className="eyebrow" style={{ marginTop: 32 }}>Compliance · Скрининг</div>
        <h1 style={{
          fontFamily: "'Lora', Georgia, serif", fontSize: 48, fontWeight: 600,
          lineHeight: 1.1, letterSpacing: '-0.01em', margin: 0, color: palette.ink,
        }}>
          Платформа<br />санкционного<br />скрининга
        </h1>
        <p style={{ maxWidth: 440, color: palette.muted, fontSize: 15, marginTop: 24, lineHeight: 1.65 }}>
          Парсинг санкционных списков, фильтрация российских юридических лиц,
          дедупликация и обогащение данных через Dadata — в одном рабочем месте.
        </p>
      </div>

      <div className="login-panel" style={{
        background: palette.surface, borderLeft: `1px solid ${palette.border}`,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 32,
      }}>
        <div style={{ width: '100%', maxWidth: 340 }}>
          <div style={{
            fontSize: 12, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase',
            color: palette.muted, marginBottom: 10,
          }}>
            Вход
          </div>
          <h2 style={{
            fontFamily: "'Lora', Georgia, serif", fontSize: 26, fontWeight: 600,
            margin: '0 0 28px', color: palette.ink,
          }}>
            Добро пожаловать
          </h2>

          <Form onFinish={onLogin} layout="vertical">
            <Form.Item
              name="username" label="Имя пользователя"
              rules={[{ required: true, message: 'Введите имя пользователя' }]}
            >
              <Input autoComplete="off" style={fieldStyle} />
            </Form.Item>
            <Form.Item
              name="password" label="Пароль"
              rules={[{ required: true, message: 'Введите пароль' }]}
            >
              <Input.Password placeholder="••••••••" style={fieldStyle} />
            </Form.Item>
            <Form.Item style={{ marginBottom: 16 }}>
              <Button type="primary" htmlType="submit" loading={loading} block
                style={{ height: 46, borderRadius: 8, fontWeight: 700 }}>
                Войти →
              </Button>
            </Form.Item>
          </Form>
          <p style={{ color: '#9B9B92', fontSize: 12, marginTop: 8 }}>
            Нет учётной записи? Обратитесь к администратору.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
